// extracted by mini-css-extract-plugin
module.exports = {"appDownloadButton":"appDownloadButton__1bdyR","appDownloadButtonImage":"appDownloadButtonImage__26rhh","appDownloadGroup":"appDownloadGroup__3Gpbo"};